import React from 'react';
import { clsx } from 'clsx';

interface AvatarProps {
  src?: string;
  alt?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const Avatar: React.FC<AvatarProps> = ({
  src,
  alt,
  size = 'md',
  icon,
  children,
  className
}) => {
  const sizeClasses = {
    sm: 'h-6 w-6 text-xs',
    md: 'h-8 w-8 text-sm',
    lg: 'h-10 w-10 text-base',
    xl: 'h-12 w-12 text-lg'
  };

  const baseClasses = 'inline-flex items-center justify-center rounded-full bg-gray-100 text-gray-500 font-medium';

  const content = () => {
    if (src) {
      return (
        <img
          src={src}
          alt={alt || 'Avatar'}
          className="h-full w-full rounded-full object-cover"
        />
      );
    }
    
    if (icon) {
      return <span className="flex items-center justify-center">{icon}</span>;
    }
    
    if (children) {
      return children;
    }
    
    return null;
  };

  return (
    <div className={clsx(baseClasses, sizeClasses[size], className)}>
      {content()}
    </div>
  );
};

export default Avatar; 